import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=6dff4660&scoped=true&"
import script from "./PrintButton.vue?vue&type=script&lang=js&"
export * from "./PrintButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff4660",
  null
  
)

export default component.exports